<template>
  <div class="edit-video-box">
    <el-dialog
      :title="'视频编辑'"
      :visible.sync="dialogVisible"
      width="800px"
      top="20px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="editParam" :rules="rules" label-width="160px">
        <div style="display: flex;">
          <div class="form-flex-box">
            <el-form-item label="视频标题:">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请谨慎修改用户上传数据"
                v-model="editParam.title"
                :disabled="editTitle"
              ></el-input>
              <el-button type="success" size="small" @click="editTitle = false"
                >修改</el-button
              >
            </el-form-item>
          </div>
          <div class="form-flex-box">
            <el-form-item label="用户ID:">
              <el-input v-model.number="editParam.uid"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-flex-box">
          <el-form-item label="封面上传:" prop="cover">
            <base-upload
              :cover="editParam.cover"
              :key="editParam.cover"
              :action="action"
              @successCallback="successCallback"
              @changeImgUrl="changeImgUrl"
              :id="sourceID"
              :wSize="360"
              :hSize="640"
              :width="'120px'"
              :height="'213px'"
              v-if="showUpload"
            ></base-upload>
          </el-form-item>
          <div class="item-box el-form-item">
            <el-form-item label="价格:" prop="coins">
              <el-input
                v-model.number="editParam.coins"
                size="small"
                placeholder="请输入价格"
              ></el-input>
            </el-form-item>
            <el-form-item label="免费时长:" prop="freeTime">
              <el-input
                v-model.number="editParam.freeTime"
                size="small"
                placeholder="请输入视频免费时长"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传类型:" prop="newsType">
              <el-select
                v-model="editParam.newsType"
                size="small"
                placeholder="请选择上传类型"
                clearable
              >
                <el-option value="SP" label="短视频"></el-option>
                <el-option value="COVER" label="图集"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否可推荐:" prop="recoWeight" v-if="false">
              <el-select
                v-model.number="editParam.recoWeight"
                placeholder="请选择可否推荐"
                size="small"
              >
                <el-option label="可推荐" :value="0"></el-option>
                <el-option label="不可推荐" :value="-1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="广告排序号:" prop="sortCode">
              <el-input
                v-model.number="editParam.sortCode"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="作品排序:" prop="worksSort">
              <el-input
                v-model.number="editParam.worksSort"
                size="small"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="flex-item">
          <el-form-item label="广告跳转链接:" prop="linkUrl">
            <el-input
              type="textarea"
              v-model="editParam.linkUrl"
              size="small"
            ></el-input>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="主题模块:" prop="subModuleID">
            <div style=" display: flex; ">
              <div style="height: 32px; ">
                <el-cascader
                  :options="secondModuleList"
                  style="width: 100%;"
                  v-model="editParam.subModuleID"
                  :show-all-levels="false"
                  :props="{ emitPath: false, expandTrigger: 'hover' }"
                  @change="handleChangeModule"
                  clearable
                ></el-cascader>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="免费专区:" prop="freeArea">
            <div style="width: 240px;">
              <el-radio v-model="editParam.freeArea" :label="Boolean(true)"
                >是</el-radio
              >
              <el-radio v-model="editParam.freeArea" :label="Boolean(false)"
                >否</el-radio
              >
            </div>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="标签:" prop="tags">
            <tag-selector
              v-model="editParam.tags"
              :tagList="tagList"
            ></tag-selector>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitDate()"
          :loading="flag"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import baseConfig from "@/utils/serverUrlConfig";
import {validatorIndex, validatorOver3, validatorWorksSort,} from "@/utils/validator";
import API from "@/api";
// import imageURLDecrypt from "@/components/imageURLDecrypt";
import TagSelector from "@/components/tagSelector";

export default {
  components: {
    TagSelector,
  },
  data() {
    return {
      dialogVisible: false,
      flag: false,
      currentModule: 0,
      secondModuleList: [],
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      tagList: [],
      sourceID: "",
      showUpload: false,
      editTitle: true,
      editParam: {
        id: "",
        tags: [],
        cover: "",
        coverThumb: "",
        freeArea: false,
        newsType: "",
        title: "",
        subModuleID: "",
        fakeLikeCount: 1,
        fakePlayCount: 1,
        uid: 0,
        fakeShareCount: 0,
        size: "",
        likeCount: 0,
        playCount: 0,
        shareCount: 0,
        freeTime: 15,
        coins: 0,
        type: 0,
        linkUrl: "",
        sortCode: "",
        worksSort: "",
      },
      // 表单验证规则
      rules: {
        cover: [
          { required: true, message: "请输入添加封面图片", trigger: "blur" },
        ],
        freeTime: [
          { required: true, message: "请输入免费时长", trigger: "blur" },
          { validator: validatorOver3, trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        coins: [
          { required: true, message: "请输入价格", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        tags: [{ required: true, message: "请选择标签", trigger: "blur" }],
        worksSort: [{ validator: validatorWorksSort, trigger: "blur" }],
      },
    };
  },
  methods: {
    getTagList() {
      const params = {};
      API.queryTagList(params).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data.list;
        }
      });
    },

    handleChangeModule(val) {
      this.editParam.subModuleID = val
    },

    transformData(originalData) {
      return originalData.map((module) => {
        return {
          value: module.moduleID,
          label: module.moduleName,
          children: module.list
            ? module.list.map((subModule) => {
                return {
                  value: subModule.moduleID,
                  label: subModule.moduleName,
                  children: subModule.subModules
                    ? subModule.subModules.map((item) => {
                        return {
                          value: item.id,
                          label: item.moduleName,
                        };
                      })
                    : null,
                };
              })
            : null,
        };
      });
    },
    // 提交验证
    submitDate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          const tags = this.editParam.tags.filter(
            (item) => this.tagList.map((e) => e.name).indexOf(item) === -1
          );
          if (tags.length > 0) {
            this.$confirm(
              `标签${tags.join(",")}不属于常用标签，确定修改？`,
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                this.editVideo();
              })
              .catch(() => {
                this.flag = false;
                return false;
              });
          } else {
            this.editVideo();
          }
        } else {
          this.flag = false;
          return false;
        }
      });
    },
    // 编辑
    editVideo() {
      API.editVideoInfo(this.editParam)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功！",
              type: "success",
            });
            this.$emit("handlerEditList");
          } else {
            this.$message.error("编辑失败！");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 标签封面上传成功回掉
    async successCallback(res) {
      this.editParam.cover = res.data.coverImg;
      this.editParam.coverThumb = res.data.coverImg;
      this.$forceUpdate();
    },
    getHotModule() {
      const params = {
        pageSize: 20,
        pageNumber: 1,
      };
      API.getModuleList(params).then((res) => {
        this.secondModuleList = this.transformData(res.data);
      });
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.getTagList();
      // this.getSubModule();
      this.getHotModule();
      this.showUpload = true;
      this.dialogVisible = true;
      this.editParam.id = data.id;
      this.editParam.cover = data.cover;
      this.editParam.title = data.title;
      this.editParam.coverThumb = data.coverThumb;
      this.editParam.newsType = data.newsType;
      this.editParam.fakeLikeCount = data.fakeLikeCount;
      this.editParam.fakePlayCount = data.fakePlayCount;
      this.editParam.fakeShareCount = data.fakeShareCount;
      this.editParam.freeArea = data.freeArea;
      this.editParam.size = data.size;
      this.editParam.likeCount = data.likeCount;
      this.editParam.playCount = data.playCount;
      this.editParam.shareCount = data.shareCount;
      this.editParam.freeTime = data.freeTime > 2 ? data.freeTime : 3;
      this.editParam.isChosen = data.chosen;
      this.editParam.coins = data.coins;
      this.editParam.recoWeight = data.recoWeight;
      this.editParam.linkUrl = data.linkUrl;
      this.editParam.sortCode = data.sortCode;
      this.editParam.worksSort = data.worksSort;
      this.editParam.uid = data.publisher.uid;

      this.sourceID = data.sourceID;
      this.editParam.tags = data.tags ? data.tags.map((item) => item.name) : [];
    },
    // 关闭回掉
    handleClose() {
      this.showUpload = false;
      this.dialogVisible = false;
      this.editTitle = true;
      this.editParam.cover = "";
      this.$forceUpdate();
      this.$refs.form.resetFields();
    },

    changeImgUrl(data) {
      this.editParam.cover = data;
      this.editParam.coverThumb = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-select,
  .el-textarea,
  .el-select > .el-input,
  .el-input {
    width: 100% !important;
  }
  .flex-item {
    width: 90%;
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .form-flex-box {
    display: flex;
    .el-form-item {
      flex: 1;
    }
    .item-box {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
